module.exports = __webpack_public_path__ + "img/add_card_bg.a576217.png";